import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  background: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  padding: 1.25rem 1.35rem;
  border-radius: 12px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.borderStrong};
    box-shadow: ${({ theme }) =>
      theme.name === 'dark'
        ? '0 8px 24px rgba(0, 0, 0, 0.28)'
        : '0 8px 24px rgba(33, 38, 45, 0.06)'};
  }
`
